import api from 'api/api.config';

const getCoaPath = (userId: string, modelId: string | number): string =>
  `/${userId}/aid-model/${modelId}/coa`;

export const getModelCoa = async (
  userId: string,
  modelId: string | number,
): Promise<unknown> => {
  const response = await api.get(getCoaPath(userId, modelId));

  return response.data;
};

export const updateModelCoa = async (
  userId: string,
  modelId: string | number,
  coaId: string | number,
  data: unknown,
): Promise<unknown> => {
  const response = await api.put(
    `${getCoaPath(userId, modelId)}/${coaId}`,
    JSON.stringify(data),
  );

  return response.data;
};
